<template>
	<div class="creat_ttk">
			<div class="f-wh-4-s1">
				<div class="creat_outk">
					<h6>创建任务</h6>
					<form id="creatForm" class="creat_form" name="creatForm">
						<p>任务名称：<input type="text" name="taskname" placeholder="请添加任务名称" /></p>
						<p>任务分类：<select>
										<option selected hidden disabled value="">请选择任务类型</option>
										<option>11</option>
										<option>22</option>
									</select>
						</p>
						<p>任务描述：<textarea placeholder="请描述任务"></textarea></p>
						<button class="submit_task" onclick="">提交任务</button>
					</form>
				</div>
			</div>
	</div>
</template>

<script>
	export default {
		props:[''],
	}
</script>

<style>
	
	
	.creat_ttk{/* display: none; width: 100vw;height: 100vh;position: absolute;top: 0;left: 0; */background-color: #021126d4;}
	
	.f-wh-4-s1 {
	    position: absolute;
	    left: 50%;
	    top: 10%;
	    width: 450px;
	    height: 404px;
	    z-index: 320;
	    box-sizing: border-box;
	    margin-left: -225px;
	    padding: 0;
	    box-shadow: #172f4f 0px 0px 5px inset;
	    background: linear-gradient(to left, #44e0ef, #44e0ef) left top no-repeat,
	    linear-gradient(to bottom, #44e0ef, #44e0ef) left top no-repeat,
	    linear-gradient(to left, #44e0ef, #44e0ef) right top no-repeat,
	    linear-gradient(to bottom, #44e0ef, #44e0ef) right top no-repeat,
	    linear-gradient(to left, #44e0ef, #44e0ef) left bottom no-repeat,
	    linear-gradient(to bottom, #44e0ef, #44e0ef) left bottom no-repeat,
	    linear-gradient(to left, #44e0ef, #44e0ef) right bottom no-repeat,
	    linear-gradient(to left, #44e0ef, #44e0ef) right bottom no-repeat;
	    background-size: 20px 20px, 10px 1px, 20px 20px, 10px 1px;
	}
	
	
	.creat_outk{display: block;
	    overflow: hidden;
	    position: absolute;
	    top: 2px;
		left: 2px;
		width: 445px;
		height: 400px;
	    background-color: #031226;}
	.creat_outk h6{
		text-align: center;
		font-size: 18px;
	font-weight: normal;
		line-height: 48px;
		letter-spacing: 0px;
		color: #3ceeff;}
	.creat_form{width: 80%;margin: 20px auto;text-align: center;}
	.creat_form p{color: #FFFFFF;margin-bottom: 15px;line-height: 35px;}
	.creat_form input,.creat_form select,.creat_form textarea{color: #FFFFFF; border: solid 1px #155ab9;background-color: transparent;width: 71%;vertical-align: top;
	    height: 33px;
	    line-height: 35px;padding: 0 2%;}
	.creat_form input{}
	.creat_form select{width: 75%;}
	.creat_form select option{color: #FFFFFF;background-color: #031226;}
	.creat_form textarea{height: 99px;}
	.submit_task{background-color: #19e8fc;
	    border-radius: 4px;
	    font-size: 14px;
	    line-height: 36px;
	    padding: 0px 20px;
	    letter-spacing: 1px;
	    color: #001738;}
</style>
